import { CircleX, RotateCcw } from "lucide-react";
import * as React from "react";

import { Badge, Tooltip } from "@/components/ui";
import { cn } from "@/lib/utils";

function revisionBadgeClass(revisionCount?: number) {
  if (!revisionCount || revisionCount <= 0) return "text-muted-foreground border-border";
  if (revisionCount === 1) return "bg-amber-50 text-amber-800 border-amber-200";
  if (revisionCount === 2) return "bg-orange-50 text-orange-800 border-orange-200";
  return "bg-red-50 text-red-800 border-red-200";
}

interface VideoProjectRevisionBadgeProps {
  revisionCount?: number | null;
  className?: string;
}

export function VideoProjectRevisionBadge({ revisionCount, className }: VideoProjectRevisionBadgeProps) {
  if (!revisionCount || revisionCount <= 0) return null;

  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          <span className={cn("inline-flex", className)}>
            <Badge
              variant="outline"
              className={cn(
                "h-5 shrink-0 gap-1 px-1.5 py-0 text-[10px] font-medium shadow-none",
                revisionBadgeClass(revisionCount)
              )}
            >
              <RotateCcw className="size-2.5" />
              {revisionCount}
            </Badge>
          </span>
        }
      />
      <Tooltip.Content>{revisionCount === 1 ? "1 revision" : `${revisionCount} revisions`}</Tooltip.Content>
    </Tooltip>
  );
}

interface VideoProjectQaFailedBadgeProps {
  className?: string;
  label?: string;
  onClick?: () => void;
}

export function VideoProjectQaFailedBadge({ className, label = "QA", onClick }: VideoProjectQaFailedBadgeProps) {
  const badge = (
    <Badge
      variant="outline"
      className="h-5 shrink-0 gap-1 border-red-200 bg-red-50 px-1.5 py-0 text-[10px] font-medium text-red-800 shadow-none"
      aria-label="QA failed"
    >
      <CircleX className="size-2.5" />
      {label}
    </Badge>
  );

  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          onClick ? (
            <button type="button" className={cn("inline-flex cursor-pointer", className)} onClick={onClick}>
              {badge}
            </button>
          ) : (
            <span className={cn("inline-flex", className)}>{badge}</span>
          )
        }
      />
      <Tooltip.Content>QA failed</Tooltip.Content>
    </Tooltip>
  );
}
